export default __webpack_public_path__ + "static/media/woman3.a7162eaf.gif";